// перемывка пока дублируется в карточке и списке
// ахтунг! из-за такой перемывки нельзя сделать два поля на одной колонке
// это типа временное решение, ну вы поняли

import { UarmRecordSend, UarmListItem, UarmRecordResponse } from './types';

export default function (apiItem: /* UarmRecordResponse */ UarmRecordSend): UarmListItem {
	const item: UarmListItem = {
		ITEM_KEY: Math.floor(Math.random() * 1e21),
		ITEM_ID: apiItem.primaryKeyValue,
		ITEM_IS_HIDDEN_BY_PARENT_COLLAPSE: false,
		ITEM_KIDS_COLLAPSED: false,
		ITEM_HAS_KIDS_TO_BE_FETCHED: false,
		ITEM_KIDS_IS_FETCHING: false,
		//ITEM_CVPM_ID: void 0,
		//ITEM_RAW_VALUE: void 0,
	};

	for (let j = 0;j < apiItem.fields.length;j++) {
		// TODO массивы!!!
		const {  value, rawValue, fieldId } = apiItem.fields[j];
		if (item[fieldId]) {
			console.error(
				`Внимание! Колонка ${fieldId} выводится в данный АРМ более одного раза. Это может привести к непредсказуемым последствиям, таким как PIRS2018-2422`,
			);
		}
		item[fieldId] = value;
		if (fieldId === 'cvpm_id') {
			// @ts-ignore
			item.ITEM_CVPM_ID = rawValue;
		}
		if (fieldId === 'name' && rawValue) {
			// @ts-ignore
			item.ITEM_RAW_VALUE = rawValue;
		}
		// !!!
		// !!!
		// не надо добавлять всякие мутные колонки типа summary_header_info, плиз!
		// помните, uarm-front - коровое универсальное решение
		// !!!
		// !!!
		if (fieldId === 'summary_header_info' && rawValue && !value) {
			// @ts-ignore
			item[fieldId] = apiItem.fields[j].rawValue;
		}
		// !!!
		// !!!
		// не надо добавлять всякие мутные колонки типа summary_header_info, плиз!
		// помните, uarm-front - коровое универсальное решение
		// !!!
		// !!!
	}

	return item;
}
